class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.productForm = null;
    this.stickyBar = null;
    this.observer = null;
    // Wait for the snippet to load before initializing
    this.stickyBar = this.querySelector('[data-sticky-bar]');
    if (!this.stickyBar) return;

    this.observeProductForm();
  }

  disconnectedCallback() {
    // Clean up the observer when the component is removed from the DOM
    if (this.observer && this.productForm) {
      this.observer.unobserve(this.productForm);
      this.observer = null;
    }
  }

  observeProductForm() {
    // Find the product form in the DOM
    this.productForm = document.querySelector('.product-form');
    if (!this.productForm) return;

    // Initialize the IntersectionObserver if not already set up
    if (!this.observer) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.hideBar();
            } else {
              this.showBar();
            }
          });
        },
        { threshold: 0 }
      );
    }

    this.observer.observe(this.productForm);
  }

  showBar() {
    this.stickyBar.classList.remove('translate-y-full');
    this.stickyBar.classList.add('translate-y-0');
  }

  hideBar() {
    this.stickyBar.classList.remove('translate-y-0');
    this.stickyBar.classList.add('translate-y-full');
  }
}

// Define the custom element
customElements.define('sticky-add-to-cart', StickyAddToCart);
